<template>
  <div class="sftp-files-header">
    <div class="d-flex flex-fill">
      <span>
        {{ $t("sections.sftpFiles.header.files") }}
      </span>
    </div>
    <div class="sftp-files-header__date">
      <span>
        {{ $t("sections.sftpFiles.header.creationDate") }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SFTPFilesHeader',
};
</script>
<style lang="scss" scoped>
.sftp-files-header {
  display: flex;
  padding: 24px;
  padding-right: 59px;
  padding-left: 39px;
  border-bottom: 2px solid var(--primary-secondary);
  color: var(--primary-secondary);
  text-transform: uppercase;
  font-weight: 600;

  &__entity {
    width: 124.5px;
  }

  &__date {
    width: 200px;
  }
}
</style>
